import React, { useMemo } from 'react'
import { Dropdown } from 'primereact/dropdown';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Tooltip } from 'primereact/tooltip';
import { normalizeSegmentsList } from '../../../Customers/Segments/segmentUtils';

export const SegmentDropdown = (props) => {
    const { selectedSubscriberSegment, setSelectedSegmentValue, selectedSegmentValue } = props;

    const { t } = useTranslation("common");

    //redux states
    const { segmentSuccess } = useSelector((state) => state.businessCustomers)


    const segmentOptions = useMemo(() => {
        const availableSegments = normalizeSegmentsList(segmentSuccess);
        if (!availableSegments.length) return [];

        if (!!selectedSubscriberSegment?.segment) {
            const currentSegment = selectedSubscriberSegment?.segment;
            setSelectedSegmentValue(currentSegment.name)
        }

        return availableSegments
            .filter(item => item.name && item.id)
            .map(item => ({
                value: item.name
            }));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [segmentSuccess, selectedSubscriberSegment]);

    const baseStyle = { fontWeight: "bold", fontSize: "14px" };
    const getStyle = (color) => ({ ...baseStyle, color });

    return (
        <div className="mt-3">
            <p className='labels'>{t("segment.segment_label")}</p>
            <Dropdown
                id="invite_segment"
                placeholder={t("segment.select_segment")}
                style={{ height: "3rem", width: "100%" }}
                className="invite_segment_dropdown"
                options={segmentOptions}
                value={selectedSegmentValue}
                optionLabel="value"
                onChange={(e) => {
                    setSelectedSegmentValue(e?.value);
                }}
            >
            </Dropdown>

            {!!selectedSubscriberSegment?.segment && <div>
                <Tooltip
                    target=".target-icon"
                    className="planInfoTooltip"
                >
                    <p className='p-2'>
                        <Trans
                            i18nKey="segment.invite_segment_tooltip"
                            values={{ segmentName: selectedSubscriberSegment?.segment.name }}
                            components={{ 1: <span style={getStyle("#000000")} />, 2: <span style={getStyle("#006644")} /> }}
                        >
                        </Trans>
                    </p>
                </Tooltip>

                <div className="mt-2">
                    <i className="target-icon pi pi-info-circle"
                        data-pr-position="bottom"
                        style={{ fontSize: "12px", cursor: "pointer", color: "#495057", fontWeight: "600" }}
                    ></i>
                </div>
            </div>}
        </div>
    )
}
